import React from 'react';

export const IconPlayCircle = ({
  size = 12,
  className,
}: {
  size?: number;
  className?: string;
}) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.31251 7.77501L7.65001 6.28751C7.75835 6.218 7.81251 6.12146 7.81251 5.99787C7.81251 5.8743 7.75835 5.77918 7.65001 5.71251L5.31251 4.22501C5.19585 4.15835 5.08126 4.15638 4.96876 4.21912C4.85626 4.28186 4.80001 4.37965 4.80001 4.51251V7.48751C4.80001 7.62037 4.85626 7.71817 4.96876 7.7809C5.08126 7.84364 5.19585 7.84168 5.31251 7.77501ZM6.00346 10.8C5.34283 10.8 4.72085 10.675 4.13751 10.425C3.55418 10.175 3.04376 9.83126 2.60626 9.39376C2.16876 8.95626 1.82501 8.44602 1.57501 7.86304C1.32501 7.28005 1.20001 6.65713 1.20001 5.99429C1.20001 5.33144 1.32501 4.71043 1.57501 4.13126C1.82501 3.5521 2.16876 3.04376 2.60626 2.60626C3.04376 2.16876 3.554 1.82501 4.13699 1.57501C4.71998 1.32501 5.3429 1.20001 6.00574 1.20001C6.66859 1.20001 7.2896 1.32501 7.86876 1.57501C8.44793 1.82501 8.95626 2.16876 9.39376 2.60626C9.83126 3.04376 10.175 3.55303 10.425 4.13406C10.675 4.7151 10.8 5.33594 10.8 5.99656C10.8 6.6572 10.675 7.27918 10.425 7.86251C10.175 8.44585 9.83126 8.95626 9.39376 9.39376C8.95626 9.83126 8.447 10.175 7.86596 10.425C7.28492 10.675 6.66409 10.8 6.00346 10.8Z"
        fill="currentColor"
      />
    </svg>
  );
};
